import './loading.style.scss'

const Loading = ()=>(
    <div>
       <div className="spinner"></div>
    </div>
)
export default Loading